import React, { useState } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Grid from '@material-ui/core/Grid'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Divider from '@material-ui/core/Divider'
import InputLabel from '@material-ui/core/InputLabel'
import OutlinedInput from '@material-ui/core/OutlinedInput'

import { Main } from '../../../../components/Layout'
import { FormControl } from '../../../../components/Forms'
import { CpfInput } from '../../../../components/Forms/Inputs'
import {
  Error,
  LoadingButton,
  Recaptcha,
  Subtitle,
} from '../../../../components'
import { Buttons } from '../../../../components/Steps'

const useStyles = makeStyles(() => ({
  center: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  divider: {
    margin: '24px 0 0',
  },
  error: {
    marginBottom: '16px',
  },
  margin: {
    marginTop: '12px',
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    width: '100%',
    padding: '30px',
  },
}))

const Form = ({ loading, notFound, failed, tryToSearch }) => {
  const classes = useStyles()

  const [recaptcha, setRecaptcha] = useState('')
  const [cpf, setCpf] = useState('')
  const [cpfResponsible, setCpfResponsible] = useState('')
  const [selfResponsible, setSelfResponsible] = useState(false)

  const responsibleCpf = selfResponsible ? cpf : cpfResponsible

  const shouldDisableSearchButton = () =>
    !recaptcha || `${cpf}`.length !== 14 || `${responsibleCpf}`.length !== 14

  return (
    <>
      <Main className={classes.main}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Subtitle>
              Preencha os campos abaixo com dados do candidato e do responsável
              para visualizar os dados inseridos e/ou imprimir o comprovante de
              inscrição
            </Subtitle>
          </Grid>

          {notFound && (
            <Grid item xs={12} className={classes.error}>
              <Error>
                Não foi possível encontrar uma inscrição para as informações
                abaixo. Verifique os dados inseridos tente novamente.
              </Error>
            </Grid>
          )}

          {failed && (
            <Grid item xs={12} className={classes.error}>
              <Error>
                Falha ao consultar a inscrição. Tente novamente em alguns
                instantes.
              </Error>
            </Grid>
          )}

          <Grid item md={6} xs={12}>
            <FormControl variant="outlined">
              <InputLabel htmlFor="cpf">CPF do candidato</InputLabel>
              <OutlinedInput
                autoFocus
                disabled={loading}
                label="CPF do candidato"
                variant="outlined"
                id="cpf"
                name="cpf"
                value={cpf}
                onChange={e => setCpf(e.target.value)}
                inputComponent={CpfInput}
              />
            </FormControl>
          </Grid>

          <Grid item md={6} xs={12}>
            <FormControl variant="outlined">
              <InputLabel htmlFor="cpfResponsible">
                CPF do responsável
              </InputLabel>
              <OutlinedInput
                disabled={loading || selfResponsible}
                label="CPF do responsável"
                variant="outlined"
                id="cpfResponsible"
                name="cpfResponsible"
                value={responsibleCpf}
                onChange={e => setCpfResponsible(e.target.value)}
                inputComponent={CpfInput}
              />
            </FormControl>

            <FormControlLabel
              control={
                <Checkbox
                  checked={selfResponsible}
                  color="primary"
                  disabled={loading}
                  id="selfResponsible"
                  name="selfResponsible"
                  onChange={e => setSelfResponsible(e.target.checked)}
                />
              }
              label="O candidato é o próprio responsável (maior de idade)"
            />
          </Grid>

          <Grid item xs={12}>
            <Divider className={classes.divider} />
          </Grid>

          <Grid item xs={12}>
            <Recaptcha onChange={setRecaptcha} />
          </Grid>
        </Grid>
      </Main>

      <Buttons extraClasses={classes.center}>
        <LoadingButton
          className={classes.margin}
          disabled={shouldDisableSearchButton()}
          loading={false}
          onClick={tryToSearch(cpf, responsibleCpf)}
        >
          Consultar
        </LoadingButton>
      </Buttons>
    </>
  )
}

export default Form
